import moment from "moment-timezone";
const isCustomerServiceOpen = (config) => {
  var _a, _b;
  const openTime = ((_a = config == null ? void 0 : config.serviceWindow) == null ? void 0 : _a.openTime) || (config == null ? void 0 : config.openTime);
  const closeTime = ((_b = config == null ? void 0 : config.serviceWindow) == null ? void 0 : _b.closeTime) || (config == null ? void 0 : config.closeTime);
  if (!openTime || !closeTime) {
    return true;
  }
  const now = moment.tz("Europe/London");
  const start = moment.tz(openTime, "HH:mm", "Europe/London");
  const end = moment.tz(closeTime, "HH:mm", "Europe/London");
  if (end.isSameOrAfter(start)) {
    return now.isBetween(start, end, void 0, "[]");
  }
  return now.isSameOrAfter(start) || now.isSameOrBefore(end);
};
const isAdvisorHandoverAvailable = (response, config) => {
  const advisorAvailable = config == null ? void 0 : config.advisorAvailable;
  const withinServiceWindow = isCustomerServiceOpen(config);
  return advisorAvailable && withinServiceWindow;
};
const getIsChatAvailable = (config) => {
  if (!config) {
    return false;
  }
  const { botAvailable = false, advisorAvailable = false } = config;
  const advisorAvailableInHours = isCustomerServiceOpen(config) && advisorAvailable === true;
  return botAvailable || advisorAvailableInHours;
};
export {
  getIsChatAvailable,
  isAdvisorHandoverAvailable,
  isCustomerServiceOpen
};
//# sourceMappingURL=advisorHandover.js.map
